import PropTypes from 'prop-types';
import PDP_v2 from './PDP_v2';
import { LegacyPdpRdpModal } from '../../generic/LegacyPdpRdpModal';

const PDPModal = ({
  visible,
  onClose,
  product,
  isCustomizationPage,
  onAddClick,
  onRemoveClick,
  dietaryProductIngredients,
}) => {
  if (product === null || product === undefined) {
    return;
  }

  return (
    <LegacyPdpRdpModal
      testid="pdp-modal"
      onClose={onClose}
      visible={visible}
      ariaLabel={`${product.name} modal`}
    >
      <PDP_v2
        product={product}
        isCustomizationPage={isCustomizationPage}
        onAddClick={onAddClick}
        onRemoveClick={onRemoveClick}
        dietaryProductIngredients={dietaryProductIngredients}
      />
    </LegacyPdpRdpModal>
  );
};

export default PDPModal;

PDPModal.propTypes = {
  closeModal: PropTypes.func,
  visible: PropTypes.bool,
  onOpen: PropTypes.func,
  onAddClick: PropTypes.func,
  onClose: PropTypes.func,
  product: PropTypes.object,
  isCustomizationPage: PropTypes.bool,
  children: PropTypes.node,
};
